<template>
   <v-list-item :href="href" :to="item.to"

      :rel="href && href !== '#' ? 'noopener' : undefined"
      :target="href && href !== '#' ? '_blank' : undefined"
      :active-class="``" @click="goto(item.to)"
   >
   <!-- v-if="hasaccess(item)" -->
      <v-list-item-icon v-if="item.icon" :icon="item.icon" class="sicon">
         <v-icon>{{ item.icon }}</v-icon>
      </v-list-item-icon>
      <v-list-item-content v-if="item.title">
         <v-list-item-title v-text="item.title" />
      </v-list-item-content>
   </v-list-item>
</template>

<script>
import Themeable from 'vuetify/lib/mixins/themeable'

export default {
   name: 'BaseItem',

   mixins: [Themeable],

   props: {
      item: {
         type: Object,
         default: () => ({
            href: undefined,
            icon: undefined,
            title: undefined,
            to: undefined,
         }),
      },
      text: {
         type: Boolean,
         default: false,
      },
      url: String,
   },

   data: () => ({
      user: Object,
   }),

   methods: {
      goto(path) {
         // force page reload coz were not using vue router
         window.location.href = path
      },

      hasaccess(pItem) {
         // console.log(this.user.usertype)
         if (Array(pItem.grantaccess).length > 0) {
            if (pItem.grantaccess[0] === 'all') {
               return true
            }
            pItem.grantaccess.forEach(item => {
               // console.log(item + ' ' + this.user.usertype)
               if (String(item).toUpperCase() === String(this.user.usertype).toUpperCase()) {
                  return true
               }
            });
         }
         return false
      }
   },

   mounted: function () {
      this.user = this.$page.user
   },

   computed: {
      iscurrentroute() {
         return (this.$route.path === this.item.to);
      },

      href () {
         return this.item.href || (!this.item.to ? '#' : undefined)
      },
   },
}
</script>
